import React from 'react'
// components
import TableField from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableField'
// views
import { TableFieldWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableField/views'
// context
import { RiskViewContext } from 'containers/Risks/RiskView/Risk/layers'
import { RiskRegisterContext } from 'containers/Risks/RisksRegister/layers'

const CustomColumns = () => {
  const { risk } = React.useContext(RiskViewContext)
  const { riskView } = React.useContext(RiskRegisterContext)

  return (
    <>
      {riskView?.customColumns?.map((column) => {
        const field = risk.customColumns?.find(({ label }) => label === column.name)?.fieldValue?.field

        if (!field) {
          return <TableFieldWrapper key={column.id} />
        }

        return <TableField key={column.id} field={field} />
      })}
    </>
  )
}

export default CustomColumns
